var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgPreview = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 116.992, height: 116.992 }, props, { children: [_jsx("path", { "data-name": "Path 229", d: "m20.73 75.532 55.154-55.154h40.757l-95.909 96.615Z", fill: "#6e7081", opacity: 0.996 }), _jsx("text", __assign({ "data-name": "PREVIEW", transform: "rotate(-45 123.852 -3.924)", fill: "#fff", fontSize: 15, fontFamily: "Lato-Regular, Lato", letterSpacing: ".02em" }, { children: _jsx("tspan", __assign({ x: 0, y: 0 }, { children: "PREVIEW" })) }))] }))); };
export default SvgPreview;
